<template>
  <div class="authority-manage roles-manage position-header">
    <navHeader :titleList="['系统管理','角色管理']" />
    <div class="rhBrand-content common-padding">
      <!-- <el-card class="box-card">
        <el-row class="common-row">

        </el-row>
      </el-card> -->
      <el-card class="box-card flex-1 table-card">
        <el-row>
          <el-button
              class="btns-add"
              icon="el-icon-plus"
              size="small"
              @click="addRole"
          >添加</el-button
          >
        </el-row>
        <el-row class="common-margin flex-1 table-main">
          <el-table :data="tableData" border style="width: 100%" class="flex-1" stripe height="100%">
            <el-table-column
              label="序号"
              width="60"
              align="center"
              type="index"
            ></el-table-column>
            <el-table-column
              prop="roleCode"
              label="角色编码"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="角色名称"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" align="center" width="320">
              <template slot-scope="scope">
                <div class="btn-box">
                  <el-button @click="edit(scope.row.id)" icon="el-icon-edit" type="text" size="medium">编辑</el-button>
                  <el-button @click="empower(scope.row.id)" icon="el-icon-thumb" type="text" size="medium">授权菜单</el-button>
                  <el-button @click="members(scope.row.id)" icon="el-icon-user" type="text" size="medium">角色成员</el-button>
                  <el-button @click="deleteRole(scope.row.id)" type="text" icon="el-icon-delete" size="medium">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="15"
            layout="total, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
    <!-- 添加编辑框 -->
    <el-dialog
      class="system-dialog"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="25%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="roleForm"
        :model="roleForm"
        :rules="roleFormRules"
        label-width="80px"
      >
        <el-form-item label="角色编码" prop="roleCode">
          <el-input
            v-model="roleForm.roleCode"
            placeholder="请输入角色编码"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色名称" prop="name">
          <el-input
            v-model="roleForm.name"
            placeholder="请输入角色名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>

    <!-- 授权菜单框 -->
    <el-dialog
      :show-close="false"
      title="授权菜单"
      :visible.sync="menuVisible"
      width="48%"
      :close-on-click-modal="false"
    >
      <tree
        :setting="setting"
        :nodes="menuData"
        @onCheck="ztreeOnCheck"
        @onCreated="handleCreated"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="menuVisible = false">取消</el-button>
        <el-button type="primary" @click="saveMenu">保存</el-button>
      </span>
    </el-dialog>

    <!-- 角色成员分配框 -->
    <el-dialog
      :show-close="false"
      title="角色成员分配"
      :visible.sync="roleVisible"
      width="48%"
      :close-on-click-modal="false"
    >
      <el-transfer
        v-model="roleValue"
        :data="roleData"
        :titles="['可选', '已选']"
        :props="{
          key: 'id',
          label: 'username',
        }"
        filterable
        :filter-method="filterMethod"
        filter-placeholder="请输入搜索内容"
      ></el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleVisible = false">取消</el-button>
        <el-button type="primary" @click="saveRole">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 引入ztree组件
import tree from 'vue-giant-tree'
import navHeader from '../../components/navHeader.vue'

export default {
  data () {
    return {
      roleId: '',
      tableData: [],
      // 编辑添加模态框
      dialogTitle: '添加角色',
      dialogVisible: false,
      isDisabled: false,
      roleForm: {
        roleCode: '',
        name: '',
        id: ''
      },
      roleFormRules: {
        roleCode: {
          required: true,
          message: '请输入角色编码',
          trigger: 'blur'
        },
        name: { required: true, message: '请输入角色名称', trigger: 'blur' }
      },
      // 授权菜单模态框
      menuVisible: false,
      // 存放选中的权限
      checkPermissions: [],
      // ztree数据
      menuData: [],
      // ztree对象
      ztreeObj: null,
      // ztree配置，参照ztree官网的配置
      setting: {
        check: {
          // 树是否带复选框或者单选框
          enable: true
        },
        data: {
          simpleData: {
            // 是否使用简单数据模式
            enable: true,
            // 树节点id，一般是后台数据库主键
            idKey: 'id',
            // 父级id
            pIdKey: 'pid',
            rootPId: '0'
          }
        },
        // ztree回调函数
        callback: {
          // 树选择事件
          onCheck: this.ztreeOnCheck
        }
      },
      // 角色成员分配模态框
      roleVisible: false,
      roleData: [],
      roleValue: [],
      currentPage: 1,
      pageSize: 15,
      total: 0,
      count: 0
    }
  },
  components: {
    tree,
    navHeader
  },
  created () {
    // this.getAccountList()
    this.getRoleList()
    // this.total = this.tableData.length
  },
  mounted () {},
  methods: {
    // 获取账号列表
    async getAccountList (id) {
      let { data: res } = await this.$http.get('/subAccount/getUserByRoleId/' + id)
      if (res.code === '200') {
        this.roleData = res.data
        this.roleValue = []
        res.data.forEach(item => {
          if (item.checked) {
            this.roleValue.push(item.id)
          }
        })
      }
    },
    // 获取角色列表
    async getRoleList () {
      let params = {
        title: '',
        pageSize: this.pageSize,
        currentPage: this.currentPage
      }
      let { data: res } = await this.$http.post(
        '/api/role/getExhibitionRoleList',
        params
      )
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      }
    },
    // 添加角色
    addRole () {
      this.dialogTitle = '添加角色'
      this.isDisabled = false
      this.dialogVisible = true
      this.roleForm = {
        roleCode: '',
        name: '',
        id: ''
      }
    },
    // 编辑
    async edit (id) {
      this.dialogTitle = '编辑角色'
      this.isDisabled = true
      // 查询编辑的数据
      let params = { id: id }
      let { data: res } = await this.$http.post(
        '/api/role/getRoleById',
        params
      )
      if (res.code === '200') {
        this.roleForm.roleCode = res.data.roleCode
        this.roleForm.name = res.data.name
        this.roleForm.id = res.data.id
      }
      this.dialogVisible = true
    },
    // 添加角色保存
    save () {
      this.$refs.roleForm.validate(async (vaild) => {
        if (vaild) {
          let form = JSON.parse(JSON.stringify(this.roleForm))
          let url = ''
          if (this.isDisabled) {
            url = '/api/role/editRole'
          } else {
            url = '/api/role/addRole'
          }
          let { data: res } = await this.$http.post(url, form)
          if (res.code === '200') {
            this.$message.success(res.msg)
            this.getRoleList()
            this.dialogVisible = false
          } else {
            this.$message.error(res.msg)
          }
        }
      })
    },
    // 授权菜单
    async empower (id) {
      this.roleId = id
      this.menuData = []
      let params = {
        userId: sessionStorage.getItem('userId'),
        roleId: id
      }
      let { data: res } = await this.$http.post(
        '/api/role/permissionTree',
        params
      )
      if (res.code === '200') {
        this.menuData = res.data
      }
      this.menuVisible = true
    },
    // 获取选择的权限
    ztreeOnCheck () {
      // 获取所有选中的节点
      let checked = this.ztreeObj.getCheckedNodes(true)
      this.checkPermissions = checked
      console.log(checked)
    },
    handleCreated (ztreeObj) {
      this.ztreeObj = ztreeObj
      // onCreated 中操作ztreeObj对象展开第一个节点
      ztreeObj.expandAll(true)
    },
    // 授权保存
    async saveMenu () {
      if (this.checkPermissions.length < 1) {
        this.$message.info('请勾选权限')
        return
      }
      let parms = {
        list: this.checkPermissions,
        roleId: this.roleId
      }
      let { data: res } = await this.$http.post(
        '/api/role/saveAssignRole',
        parms
      )
      if (res.code === '200') {
        this.menuVisible = false
        this.$message.success(res.msg)
      } else {
        this.$message.error(res.msg)
      }
    },
    // 角色成员
    members (id) {
      this.getAccountList(id)
      this.roleVisible = true
      this.roleId = id
      this.roleValue = []
    },
    // 角色搜索
    filterMethod (query, item) {
      return item.name.indexOf(query) > -1
    },
    // 角色分配保存
    async saveRole () {
      if (this.roleValue.length <= 0) { return this.$message.warning('请选择可分配账号！') }
      let params = {
        roleId: this.roleId,
        userIdList: this.roleValue
      }
      let { data: res } = await this.$http.post(
        'api/userRole/adduserRole',
        params
      )
      if (res.code === '200') {
        this.$message.success(res.msg)
        this.roleVisible = false
      } else {
        this.$message.console.error(res.msg)
      }
    },
    // 删除
    deleteRole (id) {
      let _this = this
      _this
        .$confirm('确定删除该角色吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(async () => {
          let params = {
            id: id
          }
          let { data: res } = await _this.$http.post(
            '/api/role/deleteById',
            params
          )
          if (res.code === '200') {
            _this.$message.success(res.msg)
            _this.getRoleList()
          } else {
            _this.$message.error(res.msg)
          }
        })
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getRoleList()
    }
  }
}
</script>

<style lang='less'>
.roles-manage {
  .add-role {
    float: right;
    margin: 30px 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/systemManagement/roles.vue